import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import {
  StyledHeader,
  HeaderWrapper,
  HeaderTitle,
  MenuWrapper,
  MeanuLable,
} from './Header.styled'
import { AuthLogo, PreConsentLogo, NavMenu } from '../../utilities/icons'

const PageHeader = ({
  headerTitle,
  workflow,
  haveMenu,
  isFocused,
  titleLabel,
}) => {
  const headerComponent = useRef(null)
  useEffect(() => {
    if (headerComponent.current) {
      headerComponent.current.focus()
    }
  }, [isFocused])
  return (
    <StyledHeader haveMenu={haveMenu} tabIndex="0" ref={headerComponent}>
      <HeaderWrapper haveMenu={haveMenu}>
        {workflow === 'Auth' ? (
          <AuthLogo size="46" />
        ) : (
          <PreConsentLogo size="40" />
        )}
        <HeaderTitle aria-label={titleLabel}>{headerTitle}</HeaderTitle>
      </HeaderWrapper>
      {haveMenu ? (
        <MenuWrapper workflow={workflow}>
          <NavMenu size="16" id="menu" />
          <MeanuLable htmlFor="menu">Menu</MeanuLable>
        </MenuWrapper>
      ) : null}
    </StyledHeader>
  )
}
PageHeader.propTypes = {
  headerTitle: PropTypes.string,
  workflow: PropTypes.oneOf(['Auth', 'Pre-Consent']),
  haveMenu: PropTypes.bool,
}

export default PageHeader
